import React from 'react'

export const DictionaryContext = React.createContext({})